module.exports = __webpack_public_path__ + "media/images/sports_coaching/florian@3x-90e82e7af942aca85ba663ab11495662.jpg";